/*doc
---
title: $.sidebar()
name: sidebar
category: Javascript - Components
---

// TODO Documentation and example

```html_example

```

```js_example
$(document).on('turbolinks:load', function() {

})
```
*/
(function ($) {
  'use strict'

  $.fn.sidebar = sidebar

  $.fn.sidebar.defaults = {
    classes: {
      container: 'mobile-sidebar',
      closed: 'is-closed',
      open: 'is-open',
    },
    selectors: {
      toggleButton: '.js-sidebar-toggle-button',
      sidebar: '.sidebar-wrapper',
    },
  }

  function sidebar(opts) {
    var options, $container, $sidebar, $toggleButton,
    actions = {
      persist: persistSidebar
    }

    if (typeof opts === 'string') {
      if (opts in actions) {
        actions[opts]()
      } else {
        throw new Error('"' + opts + '" action not available for DB Sidebar plugin.')
      }

    } else {
      options = $.extend({}, $.fn.sidebar.defaults, opts)
      $container = $(this)
      $sidebar = $container.find(options.selectors.sidebar)
      $toggleButton = $(options.selectors.toggleButton)

      initialize()
    }

    return this


    function initialize() {
      var isOpen = localStorage.getItem('mobile-sidebar-open')

      $container
        .addClass(options.classes.container)
        .addClass(isOpen ? options.classes.open : options.classes.closed)
        .data('sidebar-open', isOpen)

      $toggleButton.bind('click', toggleButtonClick)

      if (isOpen) {
        $container.bind('click', hideSidebar)
        $sidebar.bind('click', sidebarClick)
      }

      localStorage.removeItem('mobile-sidebar-open')
    }

    // Available Action Methods

    function persistSidebar() {
      // TODO make this a unique id so multiple sidebars can be on the DOM simultaneously.
      localStorage.setItem('mobile-sidebar-open', true)
    }


    // Helper methods

    function toggleButtonClick(event) {
      if ($container.data('sidebar-open')) {
        $container
          .data('sidebar-open', false)
          .removeClass(options.classes.open)
          .addClass(options.classes.closed)
          .unbind('click', hideSidebar)
        $sidebar
          .unbind('click', sidebarClick)
      } else {
        $container
          .data('sidebar-open', true)
          .removeClass(options.classes.closed)
          .addClass(options.classes.open)
          .bind('click', hideSidebar)
        $sidebar
          .bind('click', sidebarClick)
      }
    }

    function hideSidebar(event) {
      toggleButtonClick()
    }

    function sidebarClick(event) {
      event.stopPropagation()
    }
  }

}(jQuery))
